import { forwardRef, useState, useMemo } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { ButtonSize, ButtonVariant } from '../../../utils/buttonStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { FieldInput } from '../Field/FieldInput/FieldInput.js';
import { FieldContainer } from '../Field/FieldContainer/FieldContainer.js';
import { FieldSideContent } from '../Field/FieldSideContent/FieldSideContent.js';
import { FieldContent } from '../Field/FieldContent/FieldContent.js';
import { FieldLabel } from '../Field/FieldLabel/FieldLabel.js';
import { ButtonIcon } from '../../ButtonIcon/ButtonIcon.js';

const Input = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className,
    clearButtonTooltip,
    disabled = false,
    label,
    name,
    inputRef,
    isInvalid,
    leftContent,
    readOnly = false,
    rightContent,
    showLabel = true,
    type,
    value = '',
    placeholder,
    onBlur,
    onClear,
    onFocus,
    ...rest
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const onBlurInput = event => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setIsFocused(false);
  };
  const onFocusInput = event => {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    setIsFocused(true);
  };
  const hasFocused = useMemo(() => isFocused || value !== '' || placeholder !== undefined && placeholder.trim() !== '', [isFocused, placeholder, value]);
  return jsxs(FieldContainer, {
    className: className,
    isFocused: isFocused,
    isInvalid: isInvalid,
    disabled: disabled,
    readOnly: readOnly,
    ref: ref,
    children: [leftContent && jsx(FieldSideContent, {
      children: leftContent
    }), jsxs(FieldContent, {
      children: [showLabel && label && jsx(FieldLabel, {
        htmlFor: name,
        hasFocusedValue: hasFocused,
        isDisabled: disabled,
        children: label
      }), jsx(FieldInput, {
        disabled: disabled,
        hasFocusedValue: hasFocused,
        isInvalid: isInvalid,
        name: name,
        readOnly: readOnly,
        showLabel: showLabel && !!label,
        type: type,
        value: value,
        placeholder: placeholder,
        onBlur: onBlurInput,
        onFocus: onFocusInput,
        ref: inputRef,
        ...rest
      })]
    }), (rightContent || onClear) && jsxs(FieldSideContent, {
      align: "right",
      children: [onClear && value && jsx(ButtonIcon, {
        ariaDescribedby: clearButtonTooltip || '',
        icon: IconNames.CANCEL_FILLED,
        size: ButtonSize.SMALL,
        variant: ButtonVariant.TEXT,
        onClick: onClear,
        children: clearButtonTooltip
      }), rightContent]
    })]
  });
});
Input.displayName = 'Input';

export { Input };
//# sourceMappingURL=Input.js.map
